import React from 'react';
import {
  AccordionsItem,
  AccordionsItemHeader,
  Accordions,
  AccordionsItemSection,
  CondensedHeader,
} from '@axiom/ui';
import type { TalentSearchDisplayFilters } from '@axiom/validation';

import { TalentSearchFiltersAdmissionsGroupings } from './TalentSearchFiltersAdmissionsGroupings';
import { TalentSearchFiltersCheckboxes } from './TalentSearchFiltersCheckboxes';

export interface TalentSearchFiltersProps {
  formData: TalentSearchDisplayFilters;
  disabled?: boolean;
}

export const TalentSearchFilters = ({
  formData,
  disabled = false,
}: TalentSearchFiltersProps) => {
  return (
    <Accordions minimal name="TALENT_SEARCH_FILTERS">
      {formData.categories.map((item, pIndex) => (
        <AccordionsItem
          expanded={item.isOpen}
          key={item.title}
          name={`category_group_${item.title}`}
        >
          <AccordionsItemHeader name={`${item.title}_${item.selectedCount}`}>
            <CondensedHeader>
              {item.title}
              {item.selectedCount > 0 ? ` (${item.selectedCount})` : ''}
            </CondensedHeader>
          </AccordionsItemHeader>
          <AccordionsItemSection>
            {item.title.toUpperCase() === 'ADMISSION' ? (
              <TalentSearchFiltersAdmissionsGroupings
                data={item}
                parentIndex={pIndex}
                disabled={disabled}
              />
            ) : (
              <TalentSearchFiltersCheckboxes
                data={item.items}
                disabled={disabled}
                parentIndex={pIndex}
              />
            )}
          </AccordionsItemSection>
        </AccordionsItem>
      ))}
    </Accordions>
  );
};
